/* global THREE */
import aframe from "aframe";
import { bindEvent } from "aframe-event-decorators";
import { instantiate } from "@micosmo/aframe/lib/utils";

const reticuleOffset = new THREE.Vector3(0, 0, -0.1);
const minimumLaunchHeight = 0.04;

aframe.registerComponent("launch-controls", {
  schema: {},
  init: function() {
    this.reticule = instantiate(`<a-entity
      class="cursor"
      geometry="primitive:sphere"
      scale="0.006 0.006 0.006"
      position="${reticuleOffset.x} ${reticuleOffset.y} ${reticuleOffset.z}"
      material="shader:flat;color:blue;transparent:true;opacity:0.75"
      collider="collidesWith: ui;layer:cursor; radius: 1.2"
      meshline="lineWidth: 0.2;color:blue"
      visible="false"
      ></a-entity>`);
    this.el.parentEl.appendChild(this.reticule);

    this.enabled = true;

    this.gameBoard = document.querySelector("#game-board");
    this.omegaSilo = document.querySelector("#omega-missile-silo");
  },
  tick: (() => {
    const v1 = new THREE.Vector3();
    const v2 = new THREE.Vector3();
    const v3 = new THREE.Vector3();

    const colour = new THREE.Color("blue");
    const stretchedColour = new THREE.Color("red");
    const c1 = new THREE.Color();

    return function(t, dt) {
      /*
        this.reticule.object3D.position.copy(
        this.el.object3D.localToWorld(v1.copy(reticuleOffset)));
      */
      this.reticule.object3D.position.copy(
        v1.copy(reticuleOffset).applyMatrix4(this.el.object3D.matrix));

      const reticulePositionWorld = this.reticule.object3D.getWorldPosition(v1);

      const minimumLaunchHeightWorld =
        this.gameBoard.object3D.position.y + minimumLaunchHeight;

      let stretch = 0;
      if (reticulePositionWorld.y <= minimumLaunchHeightWorld) {
        stretch = Math.max(
          Math.min(
            Math.abs(minimumLaunchHeightWorld - reticulePositionWorld.y) / 0.25,
            1
          ),
          0
        );
        reticulePositionWorld.y = minimumLaunchHeightWorld;
        const reticulePositionLocal = this.el.parentEl.object3D.worldToLocal(
          reticulePositionWorld
        );
        this.reticule.object3D.position.copy(reticulePositionLocal);
      }

      const fromReticule = v2
        .copy(this.el.object3D.position)
        .sub(this.reticule.object3D.position)
        .divide(this.reticule.object3D.scale);

      const start = v3.copy(fromReticule).normalize();

      const c = c1.copy(colour).lerp(stretchedColour, stretch);

      this.reticule.setAttribute("meshline", {
        start: { x: start.x, y: start.y, z: start.z },
        end: { x: fromReticule.x, y: fromReticule.y, z: fromReticule.z },
        color: `#${c.getHexString()}`,
        lineWidth: 0.6 + stretch * (0.1 - 0.6)
      });
    };
  })(),
  gamestatechanged: bindEvent({ target: "[game-state]" }, function(evt) {
    const newState = evt.detail;
    if (newState !== "Playing") {
      this.enabled = false;
    } else {
      this.enabled = true;
    }
  }),
  launch: (() => {
    const v1 = new THREE.Vector3();

    return function(deltaOnly = false) {
      if (!this.enabled) {
        return;
      }

      const reticulePosition = this.reticule.object3D.getWorldPosition(v1);
      const silo = this.getNearestSilo(deltaOnly);
      if (silo !== undefined && silo.components["missile-silo"].canFire()) {
        silo.components["missile-silo"].fireAt(reticulePosition);
      } else {
        this.el.components.misound__noammo.playSound();
      }
    };
  })(),
  launchOmega: (() => {
    const v1 = new THREE.Vector3();

    return function() {
      if (!this.enabled) {
        return;
      }

      const reticulePosition = this.reticule.object3D.getWorldPosition(v1);
      const silo = this.omegaSilo;
      if (silo !== undefined && silo.components["missile-silo"].canFire()) {
        silo.components["missile-silo"].fireAt(reticulePosition);
      } else {
        this.el.components.misound__noammo.playSound();
      }
    };
  })(),
  getNearestSilo: (() => {
    const v1 = new THREE.Vector3();
    const v2 = new THREE.Vector3();

    return function(deltaOnly = false) {
      const missileSilos = document.querySelectorAll(".missile-silo");
      let nearest = undefined;
      let nearestDistance = -1;
      const reticulePosition = this.reticule.object3D.getWorldPosition(v1);
      missileSilos.forEach(silo => {
        if (
          !silo.components["missile-silo"].canFire() ||
          (deltaOnly && silo.id === "omega-missile-silo")
        ) {
          return;
        }
        const d = reticulePosition.distanceTo(
          silo.object3D.getWorldPosition(v2)
        );
        if (nearest === undefined || d < nearestDistance) {
          nearest = silo;
          nearestDistance = d;
        }
      });
      return nearest;
    };
  })()
});
